// Mapeo entre las keys internas del wizard (stepSets) y los valores
// exactos de TiposumarioID que acepta el backend en Controllers_v2_actuaciones::create().
// Fuente: switch en Controllers_v2_actuaciones.php — cualquier cambio ahí debe replicarse aquí.

export const typeToTiposumario = {
  "sumario-denuncia": "Sumario Prevencional Por Denuncia",
  "sumario-oficio": "Sumario Prevencional Por Oficio",

  // El backend almacena estos IDs con U+00A0 en lugar de espacios normales.
  "expediente-denuncia": "Expediente Contravencional por denuncia",
  "expediente-oficio": "Expediente Contravencional por oficio",

  "ufi-flagrancia": "Unidades Fiscales de Investigacion Flagrancia",
  "ufi-cavig": "Unidades Fiscales de Investigacion CAVIG",
  "ufi-anivi": "Unidades Fiscales de Investigacion ANIVI",

  "ufi-generica-denuncia": "Unidades Fiscales de Investigación Delitos Genéricos por Denuncia",
  "ufi-generica-oficio": "Unidades Fiscales de Investigación Delitos Genéricos por Oficio",
  "ufi-establecer-paradero":
    "Unidades Fiscales de Investigación Delitos Genéricos Establecer Paradero",

  "ufi-informatica-denuncia":
    "Unidades Fiscales de Investigación Delitos Informáticos y Estafas por Denuncia",
  "ufi-informatica-oficio":
    "Unidades Fiscales de Investigación Delitos Informáticos y Estafas por Oficio",

  "ufi-propiedad-denuncia":
    "Unidades Fiscales de Investigación Delitos Contra la Propiedad por Denuncia",
  "ufi-propiedad-oficio":
    "Unidades Fiscales de Investigación Delitos Contra la Propiedad por Oficio",

  "ufi-emergencias-medicas": "Unidades Fiscales de Investigacion D.E Emergencias Medicas",
  "ufi-siniestro-vial": "Unidades Fiscales de Investigacion D.E Siniestro Vial",
  "ufi-suicidio": "Unidades Fiscales de Investigacion D.E Ahorcamiento o Suicidio",
  "ufi-intoxicacion": "Unidades Fiscales de Investigacion D.E Intoxicacion",
  "ufi-incendio-vivienda": "Unidades Fiscales de Investigacion D.E Incendio en Vivienda",
  "ufi-otros": "Unidades Fiscales de Investigacion D.E Otros",

  "preliminares-incendio-vivienda": "Actuacion Preliminar por Incendio en Vivienda",
  "preliminares-establecer-procedencia": "Actuacion Preliminar para Establecer Procedencias",
  "preliminares-fuga-menor": "Actuacion Preliminar por Fuga de Menor",
  "preliminares-incendio-automotor": "Actuacion Preliminar por Incendio de Automotor",
  "preliminares-siniestro-vial": "Actuacion Preliminar por Siniestro Vial",
  "preliminares-caida-casual": "Actuacion Preliminar por Caida Casual",
  "preliminares-suicidio": "Actuacion Preliminar por Tentativa de Suicidio",
  "preliminares-otros": "Actuacion Preliminar - Otros",
};

export const getTiposumarioID = (key) => typeToTiposumario[key] || "";

// Helpers de clasificación basados en el string final del backend.
export const isSumarioDenuncia = (tipo) => tipo === "Sumario Prevencional Por Denuncia";
export const isSumarioOficio = (tipo) => tipo === "Sumario Prevencional Por Oficio";
export const isExpediente = (tipo) => tipo.includes("Expediente");
export const isUfi = (tipo) => /Unidades Fiscales/i.test(tipo);
export const isPreliminar = (tipo) => /Actuacion Preliminar/.test(tipo);
export const isOficio = (tipo) => /oficio/i.test(tipo);
export const isDenuncia = (tipo) => /denuncia/i.test(tipo);
export const isEstablecerParadero = (tipo) => /Establecer Paradero/i.test(tipo);

// Mínimo de caracteres requeridos para el campo Relato según el tipo de actuación.
// Expediente, denuncia y oficio → 400. Resto (UFI especiales, preliminares) → 600.
export const getRelatoMinLength = (tipoKey) => {
  const tipo = typeToTiposumario[tipoKey] || "";
  if (isExpediente(tipo)) return 400;
  return 600;
};

// Tipos de denuncia que se mandan en $_POST["Denuncia"]["TipodenunciaID"].
// Según la convención histórica del front (formatPost.js) el backend distingue:
// - "Denuncia" (cuando viene con afectado/a haciendo la denuncia)
// - "Oficio"   (cuando el origen es un parte policial)
// - "Genéricos Establecer Paradero" y otros casos especiales ya cableados por tipo.
export const getTipoDenuncia = (key) => {
  if (key === "ufi-establecer-paradero") return "Genéricos Establecer Paradero";
  const tipo = typeToTiposumario[key] || "";
  if (isOficio(tipo)) return "Oficio";
  return "Denuncia";
};
